/**
 * One induction reminder for the worker, not a link per course.
 * The portal remains the authority for official links and current requirements.
 */
export function buildInductionReminderMessage({ firstName, portalLink } = {}) {
  const greeting = String(firstName || '').trim().split(/\s+/)[0] || 'there';
  return [
    `Hello ${greeting},`,
    '',
    'You can start your Care Certificate induction in CareDock now, even while your other documents are being checked.',
    `Open induction: ${portalLink || ''}`,
    'Choose your next standard, follow the official NHS learning link where available, and submit your answers.',
    'If you receive a training certificate, upload it through My training. Your manager checks the certificate and any required practical assessment.',
    'If anything does not open, please reply to the recruitment team for help.',
  ].join('\n');
}

export function buildInductionReminderLinks({ contact = {}, message } = {}) {
  const whatsappNumber = String(contact.whatsapp_recipient || '').replace(/[^0-9]/g, '');
  const email = String(contact.email || '').trim();
  const body = encodeURIComponent(message || '');
  return {
    whatsapp: whatsappNumber ? `https://wa.me/${whatsappNumber}?text=${body}` : null,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      ? `mailto:${email}?subject=${encodeURIComponent('Your Care Certificate induction')}&body=${body}`
      : null,
  };
}
